import React from 'react';
import { ADD_TO_CART } from '../data/Localization';

/**
 * Renders a button component for adding a product to the cart.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Function} props.onClick - The function to be called when the button is clicked.
 * @param {string} props.ariaText - The text to be used for accessibility purposes.
 * @param {boolean} props.disabled - Indicates whether the button is disabled.
 * @param {string} props.className - The CSS class name to be applied to the button.
 * @param {string} props.label - The label text to be displayed on the button.
 * @returns {JSX.Element} The rendered AddToCartButton component.
 */
const AddToCartButton = (props) => {
	return (
		<calcite-button
			onClick={props.onClick}
			label={Granite.I18n.get('Add to cart product', [props.ariaText])}
			data-click="handleAddToCart"
			scale="l"
			disabled={!!props.disabled || undefined}
			class={`prc__add-to-cart ${props.className}`}>
			<span>{props.label || ADD_TO_CART}</span>
		</calcite-button>
	);
};

export default AddToCartButton;
